
import { Box, Heading, Card, CardBody, Stack, Table, Tbody, Tr, Td, Th, CardFooter, Text, Thead, useToast, Icon, Tooltip } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { react_api } from "../../config";
import { HTTP_STATUS_CODES } from "../../GrinsCostant";
import logout from "../../services/authService";
import createAxiosInstance from "../../interceptors/useAxiosInterceptors"
import { useSession } from '../../SessionContext';
import { useNavigate } from "react-router-dom";
import convertUtcToLocal from "../../services/utils";
import { Button } from "@chakra-ui/react";
import { HStack } from "@chakra-ui/react";
import { InfoIcon, SearchIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";
import { BsArrowRightCircleFill } from "react-icons/bs";
export default function MyServices() {
  const { t } = useTranslation();

  const [services, setServices] = useState([]);
  const toast = useToast();
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const { updateSessionData, clearSessionData } = useSession();

  const axiosInstance = createAxiosInstance(async (axiosInstance) => {

    logout(t, clearSessionData, navigate, toast, axiosInstance)
  });


  const fetchInternalServices = async () => {
    try {

      const richiesta = {
        BearerToken: sessionStorage.getItem("token"),
        username: sessionStorage.getItem("username"),
        //caseType: CASE_TYPE.CATALOG_ALL,
      }
      const options = {

        headers: {
          'Content-Type': 'application/json',
        }
      }

      // const urlFetch = `${react_api}/privateServices/getServicesADP`;
      const urlFetch = `${react_api}/services/getInternalServiceADP`;

      const response = await axiosInstance.post(urlFetch, richiesta, options)

      const result = response.data;
      if (result.status === HTTP_STATUS_CODES.BAD_REQUEST || result.status === HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR) {
        toast({
          title: t('toastMsg.error'),
          description: t(`messageBE.${result.message}`),
          position: "top",
          status: 'error',
          duration: 4000,
          isClosable: true
        });
      }
      if (result.status === HTTP_STATUS_CODES.OK) {
        console.log(result);
        setServices(result.services)

      }
      else {

        setMessage(result.message);
      }
    } catch (error) {
      toast({
        title: t('toastMsg.callError'),
        description: String(error),
        position: "top",
        status: 'warning',
        duration: 4000,
        isClosable: true
      });
    }
  };

  useEffect(() => {


    const fetchServices = async () => {
      try {

        const richiesta = {
          BearerToken: sessionStorage.getItem("token"),
          username: sessionStorage.getItem("username"),
          //caseType: CASE_TYPE.CATALOG_ALL,
        }
        const options = {

          headers: {
            'Content-Type': 'application/json',
          }
        }

        const urlFetch = `${react_api}/privateServices/getServicesADP`;

        const response = await axiosInstance.post(urlFetch, richiesta, options)

        const result = response.data;
        if (result.status === HTTP_STATUS_CODES.BAD_REQUEST || result.status === HTTP_STATUS_CODES.INTERNAL_SERVER_ERROR) {
          toast({
            title: t('toastMsg.error'),
            description: t(`messageBE.${result.message}`),
            position: "top",
            status: 'error',
            duration: 4000,
            isClosable: true
          });
        }
        if (result.status === HTTP_STATUS_CODES.OK) {
          setServices(result.services)

        }
        else {

          setMessage(result.message);
        }
      } catch (error) {
        toast({
          title: t('toastMsg.callError'),
          description: String(error),
          position: "top",
          status: 'warning',
          duration: 4000,
          isClosable: true
        });
      }
    };

    fetchServices();
    fetchInternalServices();
  }
    , []);

  /*
  Carica i risultati in una tabella ogni volta che viene caricata la pagina (useEffect) interrogando l'endpoint con 
  l'invio di un json contente il token di identificaione, l'username dellutente e una costante caseType per indicare al backend 
  di quale chiamata si tratta e quali paremetri deve inviarci. Per consultare i case type consultare il file CaseTypeConstant.js  
  */

  return (

    <Box h="100%" w="100%" overflowY={"auto"}>
      {/* <Box alignItems={"center"} justifyContent={"space-between"} display={"flex"} color={"rgba(11,78,90,255)"} bgColor={"#f6f3ec"}> */}
      <Box
        position="sticky"
        top="0" 
        zIndex="800" 
        alignItems="center"
        justifyContent="space-between"
        display="flex"
        color="rgba(11,78,90,255)"
        bgColor="#f6f3ec"
        px="4"
        py="2"
        boxShadow="md"
      >
        <Heading size='xl' color={"rgba(11,78,90,255)"} >{t('services.name')}</Heading>
      </Box>
      <Box direction="column" h="100vh" boxShadow="lg" mt="4" ml="4" mr="4">

        <Table size="md" variant='striped' bgcolor="white">
          <Thead fontFamily={"-moz-initial"} bg={"#0888BE"} position="sticky" top="0" zIndex={0}>
            <Tr>
              <Th color={"white"} >{t('services.table.title')}</Th>
              <Th color={"white"} width="60%">{t('services.table.description')}</Th>
              <Th color={"white"} width="20%">{t('services.table.actions')}</Th></Tr>
          </Thead>
          <Tbody>
            {services.length > 0 ? (
              (services.map((item, index) => (
                <Tr>
                  <Td whiteSpace={"normal"} wordBreak={"break-word"}><b>{item.title}</b></Td>
                  <Td whiteSpace={"normal"} wordBreak={"break-word"}>{item.description_lite}</Td>
                  <Td whiteSpace={"normal"} wordBreak={"break-word"}>
                    <HStack align={"center"} wrap="wrap">
                      <Tooltip label={t('toolTip.tooltipMyServices.goToService')} placement="right" closeOnClick={true}>
                        <span>
                          <Icon as={BsArrowRightCircleFill} _hover={{ color: "#0888BE" }} onClick={() => {
                            navigate("/service-intro/?hideHeader=true&hideNavbar=true", { state: item })
                          }} />
                        </span>
                      </Tooltip>
                    </HStack>
                  </Td>
                </Tr>
              )))) : (<Tr alignContent={"center"}><Text fontSize={"lg"} color="rgba(11,78,90,255)">{message ? t(`messageBE.${message}`) : ''}</Text></Tr>)}

          </Tbody>
        </Table>

      </Box>
    </Box>

  )

}